import React from 'react';

const SvgFolderNSEnforced = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21.6 10.07v-.59A3.61 3.61 0 0018 5.87h-4.51l-2.12-2.1a.71.71 0 00-.53-.22H6a3.6 3.6 0 00-3.6 3.6v9.7a3.6 3.6 0 003.6 3.6h5.217V19H6a2.1 2.1 0 01-2.11-2.15V9.48l.01-2.33A2.1 2.1 0 016 5.05h4.52l2.12 2.1c.14.14.331.22.53.22H18a2.1 2.1 0 012.1 2.11v.59h1.5z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line spellcheck/spell-checker
        d="M17.646 10.204l1.35 1.348h1.92a.694.694 0 01.684.577v2.03l1.35 1.357a.69.69 0 01.08.875l-.08.096-1.332 1.365v1.907a.708.708 0 01-.579.692h-2.043l-1.35 1.347a.702.702 0 01-.877.088l-.097-.088-1.368-1.338h-1.911a.702.702 0 01-.693-.578v-2.03l-1.35-1.348a.708.708 0 01-.088-.875l.088-.096 1.35-1.356v-1.925a.699.699 0 01.702-.7h1.902l1.35-1.348a.702.702 0 01.992 0zm-1.32 7.936c.142 0 .28-.045.395-.128l3.259-2.684.076-.086.004-.005a.663.663 0 000-.853.673.673 0 00-.943-.093l-2.773 2.247-1.167-1.165-.101-.08-.011-.007a.673.673 0 00-.826 1.05l1.592 1.597.092.073.007.006a.673.673 0 00.396.128z"
        fill="currentColor"
      />
    </svg>
  );
});
export default SvgFolderNSEnforced;
SvgFolderNSEnforced.iconName = 'folder-ns-enforced';
SvgFolderNSEnforced.displayName = 'SvgFolderNSEnforced';
